import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useSelector } from 'react-redux';
import Layout from '../../../Layout';
import AuthenticationHoc from '../../../System/AuthenticationHoc';
import MyPageNews from '../../../Ui/News/MyPageNews';
import SideMenu from '../SideMenu';
const MyPage = () => {
    const news = useSelector((state) => (state.news || {}).list || []);
    const profile = useSelector((state) => state.profile);
    return (_jsx(Layout, Object.assign({ mainClassName: 'l-main' }, { children: _jsxs("div", Object.assign({ className: 'l-container l-container-12 l-contents is-professional-mypage' }, { children: [_jsx(SideMenu, { profile: profile }), _jsx("div", Object.assign({ className: 'l-container-9' }, { children: _jsx(MyPageNews, { list: news }) }))] })) })));
};
export default AuthenticationHoc({ isFreeProfessional: true })(MyPage);
